import { createFeatureSelector, createSelector } from "@ngrx/store";
import { COLOR_PALETTE, ThemeState } from "../model/theme.model";

export const selectThemeState = createFeatureSelector<ThemeState>('theme');
export const selectPrimaryColor = createSelector(selectThemeState, (state) => state.primaryColor);
export const selectFont = createSelector(selectThemeState, (state) => state.font);
export const selectDarkMode = createSelector(selectThemeState, (state) => state.darkMode);
export const selectColorPalette = createSelector(selectThemeState, (state) => state.colorPalette);
export const selectFontStyles = createSelector(selectThemeState, (state) => state.fontStyles);

export const selectPrimaryColorPalette = createSelector(
    selectThemeState,
    (state) => ({
      ...COLOR_PALETTE[state.primaryColor]
    })
  );